<template>
  <div class='ml-10'>
    <div class='mb-2 d-flex align-center justify-end'>
      <v-btn text x-small class='ml-3' color='primary' depressed
             @click='refresh'
             style='transform: translateX(-10px)'>
        <v-icon size='20'>{{ icons.mdiRefresh }}</v-icon>
        <span class='ml-1'>刷新</span>
      </v-btn>
    </div>
    <vxe-table
      style='z-index: 2'
      ref='dataTable'
      class='scroll-table'
      border
      resizable
      show-header-overflow
      show-overflow
      :height='tableHeight'
      :loading='tableLoading'
      size='small'
      :row-config='{isHover: true}'
      :data='dataList'
      @filter-change='search'
      :filter-config='{ remote: true }'
    >
      <vxe-column field='createBy' title='Member' :filters="[{ data: '' }]" width='200'>
        <template #filter='{ $panel, column }'>
          <vxe-input v-for='(option, index) in column.filters' :key='index' v-model='option.data'
                     @input='$panel.changeOption($event, !!option.data, option)'>
          </vxe-input>
        </template>
      </vxe-column>
<!--      <vxe-column field='subject' title='Subject' :filters="[{ data: '' }]" width='240'>-->
<!--        <template #filter='{ $panel, column }'>-->
<!--          <vxe-input v-for='(option, index) in column.filters' :key='index' v-model='option.data'-->
<!--                     @input='$panel.changeOption($event, !!option.data, option)'>-->
<!--          </vxe-input>-->
<!--        </template>-->
<!--      </vxe-column>-->
      <vxe-column field='suggestion' title='Suggestion'>
      </vxe-column>
      <vxe-column field='adminFeedback' title='Admin Feedback'>
      </vxe-column>
      <vxe-column field='createTime' width='150' title='Create Time' sortable
                  show-header-overflow show-overflow />
      <vxe-column field='updateBy' title='Update By' width='200'>
      </vxe-column>
      <vxe-column field='updateTime' title='Update Time' width='200'>
      </vxe-column>
      <vxe-column title='Operation' width='100' align='center'>
        <template #default='{ row }'>
          <v-btn color='primary' text class='mr-1' small @click='openAdminFeedbackDialog(row)'>
            <v-icon small>{{ icons.mdiCommentAccount }}</v-icon>
          </v-btn>
        </template>
      </vxe-column>
    </vxe-table>
    <vxe-pager
      :current-page='pagerOption.pageNum'
      :page-size='pagerOption.pageSize'
      :total='pagerOption.totalData'
      :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
      :page-sizes='[10, 20, 50, 100]'
      @page-change='changePerPage'
    />

    <v-dialog v-model="adminFeedbackDialog" width="400px" persistent>
      <v-form ref="feedbackForm" v-model="valid" :lazy-validation="lazy">
        <v-card class="mx-auto">
          <v-card-title class="pa-4 d-flex align-center dialog-titile-bg">
            <img
              :src="require('@/assets/images/feedback-icon.png')"
              alt=""
              style="height: 30px; display: block"
            />
            <div class="ml-1 title-color">Give Reply</div>
            <v-spacer></v-spacer>
            <v-icon
              @click=";(dialog = false), $refs.feedbackForm.reset()"
            >{{ icons.mdiClose }}
            </v-icon
            >
          </v-card-title>
          <v-card-text>
            <v-textarea
              label="Reply *"
              placeholder="Please enter..."
              v-model="feedbackSuggestionData.adminFeedback"
              :rules="[v => !!v || '']"
              outlined
              dense
              rows="5"
              counter
              maxlength="2000"
              :counterValue="counterValue"
            >
            </v-textarea>
          </v-card-text>
          <v-card-actions class="dialog-bottom-bg">
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              small
              class=""
              outlined
              @click="
                  adminFeedbackDialog = false
                  $refs.feedbackForm.reset()
                "
            >
              取消
            </v-btn>
            <v-btn
              color="white"
              small
              class="ml-2 primary"
              outlined
              height="14px"
              :loading="feedbackSaveLoading"
              @click="validate()"
            >
              确认
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>
<script>
import { adminFeedback, getFeedbackPageList } from '@/modules/chat/api/index'
import { mdiThumbDownOutline, mdiThumbUpOutline, mdiRefresh, mdiCommentAccount } from '@mdi/js'

export default {
  data() {
    return {
      tableLoading: false,
      dataList: [],
      pagerOption: {
        pageNum: 1,
        pageSize: 20,
        totalData: 0,
      },
      icons: {
        mdiThumbDownOutline, mdiThumbUpOutline, mdiRefresh, mdiCommentAccount,
      },
      searchParams: {
        nameOfJobList: [],
        createBy: null,
        likeType: null,
        likeTypeList: [],
        queryContent: null,
        answerContent: null,
      },
      tableHeight: 0,
      selectedRow: null,
      adminFeedbackDialog: false,
      valid: true,
      lazy: false,
      feedbackSuggestionData: {
        adminFeedback: null,
      },
      feedbackSaveLoading: false,
    }
  },
  created() {
    this.getPageList()
  },
  mounted() {
    this.getScreenHeight()
    // 监听窗口大小变化事件
    window.addEventListener('resize', this.getScreenHeight)
  },
  beforeDestroy() {
    // 组件销毁前移除事件监听器
    window.removeEventListener('resize', this.getScreenHeight)
  },
  methods: {
    refresh() {
      this.pagerOption.pageNum = 1
      this.pagerOption.pageSize = 20
      this.getPageList()
    },
    getScreenHeight() {
      this.tableHeight = window.innerHeight - 64 - 50 - 50
    },
    search(params) {
      const { filters } = params
      console.log('🚀 ~ search ~ filters:', filters)
      this.searchParams.createBy = null
      this.searchParams.nameOfJobList = []
      this.searchParams.likeTypeList = []
      this.searchParams.queryContent = null
      this.searchParams.answerContent = null
      filters.forEach(item => {
        if (item.property === 'nameOfJob') {
          this.searchParams.nameOfJobList = item.values
        } else if (item.property === 'likeType') {
          this.searchParams.likeTypeList = item.values
        } else {
          this.searchParams[item.property] = item.datas[0]
        }
      })
      console.log(this.searchParams)
      this.getPageList()
    },
    changePerPage(currentPage) {
      this.pagerOption.pageNum = currentPage.currentPage
      this.pagerOption.pageSize = currentPage.pageSize
      this.getPageList()
    },
    async getPageList() {
      this.tableLoading = true
      const {
        data: {
          code,
          data,
        },
      } = await getFeedbackPageList({ ...this.pagerOption, ...this.searchParams })
      if (code === 200) {
        this.dataList = data.records
        this.pagerOption.totalData = data.total
      }
      this.tableLoading = false
    },
    openAdminFeedbackDialog(row) {
      this.selectedRow = row
      this.adminFeedbackDialog = true
    },
    counterValue(val) {
      function convertToEmptyString(value) {
        return value === null || value === undefined ? '' : value
      }

      return (convertToEmptyString(val) + '').length
    },
    validate() {
      if (this.$refs.feedbackForm.validate()) {
        this.setAdminFeedback()
      }
    },
    setAdminFeedback() {
      this.feedbackSaveLoading = true
      // eslint-disable-next-line no-unused-vars
      adminFeedback({
        ...this.selectedRow,
        adminFeedback: this.feedbackSuggestionData.adminFeedback,
      }).then(({ data: { data, code } }) => {
        if (code === 200) {
          this.$message.success('回复成功！')
          this.adminFeedbackDialog = false
          this.getPageList()
        }
      }).finally(() => {
        this.feedbackSaveLoading = false
      })
    },
  },
}
</script>
